import httpRequest from "services/httpRequest";

const prefix = "/api/subscription-package";

export const onGetSubscriptionsPage = async params => {
  const result = await httpRequest({
    url: `${prefix}`,
    method: "GET",
    params: { ...params },
  });
  return result;
};

export const onGetAllSubscriptions = async params => {
  const result = await httpRequest({
    url: `${prefix}/all`,
    method: "GET",
    params: params,
  });
  return result;
};

export const onGetSubscriptionDetail = async params => {
  const result = await httpRequest({
    url: `${prefix}/${params}`,
    method: "GET",
    params: { ...params },
  });
  return result;
};
export const onAddSubscription = async params => {
  const result = await httpRequest({
    url: `${prefix}`,
    method: "POST",
    data: { ...params.data },
    successMessage: "toast.create_success",
  });
  return result;
};

export const onUpdateSubscription = async params => {
  const result = await httpRequest({
    url: `${prefix}/${params.id}`,
    method: "PUT",
    data: { ...params.data },
    successMessage: "toast.update_success",
  });
  return result;
};

export const onDeleteSubscription = async params => {
  const result = await httpRequest({
    url: `${prefix}/${params}`,
    method: "DELETE",
    successMessage: "toast.delete_success",
  });
  return result;
};

export const onSelectSubscription = async params => {
  const result = await httpRequest({
    url: "/api/workspace-subscription-package",
    method: "POST",
    data: params,
  });
  return result;
};

export const onGetUseSubscription = async params => {
  const result = await httpRequest({
    url: `/api/workspace-subscription-package`,
    method: "GET",
    params: params ? { workspace_id: params } : null,
  });
  return result;
};

export const onCancelDowngradeSubscription = async params => {
  const result = await httpRequest({
    url: `/api/workspace-subscription-package/cancel`,
    method: "PUT",
    data: params,
    successMessage: "toast.cancelDowngrade_success",
  });
  return result;
};
